import React, { useState, useContext } from 'react';
import GradientButton from '../../../../../customMui/newButton/newButton';
import { makeStyles } from '@mui/styles';
import { Button, InputAdornment, TextField } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import callApi from '../../../../libs/callApi';
import ControllerContext from '../../../../../../RoomControllerSocketContext';
const useStyles = makeStyles((theme) => ({

	textField : {
		'& .MuiInputBase-root' : {
			color : 'black'
		},
		'& .MuiFormLabel-root' : {
			color : 'black'
		},
		'& .MuiFormLabel-root.Mui-focused' : {
			color : 'black'
		}
	}
}));
const MeetingPasscode = (props) =>
{
	const classes = useStyles();
	const { pluginSocket } = useContext(ControllerContext);
	const [ showPass, setShowPass ] = useState(false);
	const [ password, setpassword ] = useState('');
	const meetingId = props.meetingId;
	const isrecurring = props.isrecurring;
	const navigate = useHistory();

	async function getMeetings()
	{
		props?.setIsLoading(true);
		console.log('my props', meetingId);
		const data = JSON.stringify({
			'path'    : '/schedule/publicpostmeeting',
			'method'  : 'POST',
			'apiBody' : {
				'isMeetingProtected' : true,
				'isRecurring'        : isrecurring,
				'meetingId'          : `${meetingId}`,
				'meetingPassword'    : `${password}`
			}

		});

		try
		{
			const response = await callApi(data);

			console.log('meeting data===', JSON.stringify(response));
			if (JSON.stringify(response?.status) === 'false')
			{
				toast.error(response?.data);
			}
			else
			if (response?.data?._id)
			{

				const meetingData = { ...response?.data, displayName: props?.name };

				pluginSocket?.emit('startMeeting', meetingData);

				const meetingType = btoa(response?.data?.scheduleType);

				const uid = btoa(props?.email);
				const displayName = btoa(props?.name);

				const { controllerUniqueId, desktopUniqueId } = await window?.electron?.ipcRenderer?.invoke('requestToJoinRoom');
				const volume = await window?.electron?.ipcRenderer?.invoke('getSystemVolume');

				pluginSocket?.emit('receiveSystemVolume', { volume });

				navigate.push(`/${response?.data?.sessionId}?projectId=${import.meta.env.VITE_ProjectId}&uid=${uid}&displayName=${displayName}&meetingType=${meetingType}&pairId=${desktopUniqueId}_${controllerUniqueId}`);

			}
			props?.setIsLoading(false);
		}
		catch (error)
		{
			console.log(error);
			props?.setIsLoading(false);
		}
	}
	const handleShowPass = () =>
	{
		setShowPass((prevShowPass) => !prevShowPass);
	};
	const handlepassword = () =>
	{
		getMeetings();
	};
	const handlepasswordinput = (event) =>
	{
		setpassword(event.target.value);
	};

	return (
		<div className='flexCol dialogBD'>
			<div className='flexCol dialogBox '>
				<div className='flexRow pdngSM aCntr jBtwn brdrBSM'>
					<span className='mHdng ldSpan pdngXS'>
						Enter Meeting Passcode
					</span>
					<img
						src='/icons/Cancel.svg'
						alt='cancel'
						className='IconImage aEnd jEnd pointer'
						onClick={props?.handleClosePasscode}
					/>
				</div>
				<div className='flexCol pdngHMD'>
					<div className='flexRow pdngSM mrgnTXS'>
						<TextField
							id='outlined-basic'
							className={classes.textField}
							size='large'
							fullWidth
							type={showPass ? 'text' : 'password'}
							label='Passcode'
							variant='standard'
							name='password'
							inputProps={{ maxLength: 20 }}
							onChange={handlepasswordinput}
							InputProps={{
								endAdornment : (
									<InputAdornment position='end' onClick={handleShowPass}>
										{showPass ? (
											<VisibilityOutlinedIcon className='pointer' />
										) : (
											<VisibilityOffIcon className='pointer' />
										)}
									</InputAdornment>
								)
							}}
						/>
					</div>
					<div className='flexRow aEnd jEnd mrgnVLG gap16'>
						<Button
							variant='outlined'
							disableElevation
							style={{ borderRadius: '10px' }}
							onClick={props?.handleClosePasscode}
						>
							cancel
						</Button>

						<GradientButton
							variant='contained'
							disableElevation
							disabled={password.length < 6}
							onClick={handlepassword}
						>
							ok
						</GradientButton>
					</div>
				</div>
			</div>
			<ToastContainer
				position='top-right'
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnVisibilityChange
				draggable
				pauseOnHover
			/>
		</div>

	);
};

export default MeetingPasscode;
